module.exports = __webpack_public_path__ + "img/shutterstock_790582078.87869f9d.jpg";